import { writable, derived } from 'svelte/store';

// Which Firestore source the dashboard reads ecard/view data from:
//   'prod'    → the default (production) database
//   'staging' → the named `staging` database (same GCP project)
// Sent as the X-Datasource header on every /api call (see api.js); the server
// routes each ecard/view query to the matching DB. Persisted so the choice
// survives reloads. NOTE: only affects Firestore-sourced data (ecards + views);
// the Orders pages are Shopify-sourced and always show prod.
const KEY = 'ch_datasource';

function initial() {
  try { return localStorage.getItem(KEY) === 'staging' ? 'staging' : 'prod'; }
  catch (_) { return 'prod'; }
}

export const datasource = writable(initial());
datasource.subscribe((v) => {
  try { localStorage.setItem(KEY, v); } catch (_) { /* ignore */ }
});

// Ecard viewer base for the current source — staff "preview" links point here so
// a preview opens the matching environment's viewer (and we tag it ?crdv=a).
export const ecardBase = derived(datasource, ($d) =>
  ($d === 'staging' ? 'https://staging-ecard.cardhero.com' : 'https://ecard.cardhero.com')
);
